<template>
  <div class="mission-detail-timeslots tw-flex">
    <mission-detail-group-item
      :title="$t('app.labels.date')"
      class="tw-w-1/2"
      data-test="date"
    >
      {{ date }}
    </mission-detail-group-item>
    <mission-detail-group-item
      :title="$t('app.labels.schedule')"
      class="tw-w-1/2"
      data-test="schedule"
    >
      {{ schedule }}
    </mission-detail-group-item>
  </div>
</template>

<script>
  import { defineComponent, computed, toRefs } from '@vue/composition-api'

  import useI18n from '@/composables/useI18n'
  import useMoment from '@/composables/useMoment'
  import MissionDetailGroupItem from '@/views/Carriers/Missions/views/_subs/MissionDetail/components/MissionDetailGroupItem'

  export default defineComponent({
    name: 'MissionDetailTimeslots',
    components: {
      MissionDetailGroupItem
    },
    props: {
      mission: {
        type: Object,
        required: true
      },
      direction: {
        type: String,
        required: true
      }
    },
    setup (props) {
      const { mission, direction } = toRefs(props)
      const i18n = useI18n()
      const moment = useMoment()

      const date = computed(() => {
        const { flexible, date } = mission.value[direction.value].time_slot
        const dateString = moment.value(date).format('ll')

        const isFlexible = flexible === true
        const flexibleLabel = direction.value === 'pickup'
          ? i18n.value.t('missions.labels.pickup.date_flexible', {
            date: dateString
          })
          : i18n.value.t('missions.labels.delivery.date_flexible', {
            date: dateString
          })

        return isFlexible
          ? flexibleLabel
          : i18n.value.t('missions.labels.pickup.date', {
            date: dateString
          })
      })

      const schedule = computed(() => {
        const {
          start_time: startTime,
          end_time: endTime,
          date
        } = mission.value[direction.value].time_slot

        const start = moment.value(`${date} ${startTime}`).format('LT')
        const end = moment.value(`${date} ${endTime}`).format('LT')

        return start === end ? start : `${start} - ${end}`
      })

      return {
        date,
        schedule
      }
    }
  })
</script>

<style lang="scss" scoped>.mission-detail-timeslots {
  margin-bottom: 44px;
}
.mission-detail-timeslots .mission-detail-group-item:nth-child(1) {
  margin-right: 2rem;
  position: relative;
}
.mission-detail-timeslots .mission-detail-group-item:nth-child(1)::after {
  --tw-bg-opacity: 1;
  background-color: rgba(214, 214, 218, var(--tw-bg-opacity));
  height: 100%;
  position: absolute;
  content: '';
  width: 1px;
  right: -1rem;
}</style>
